import { useEffect, useMemo } from 'react';
import * as THREE from 'three';
import { ImageMaterial } from './ImageMaterial';

type Props = THREE.MaterialParameters & {
  map: THREE.Texture;
  brightness: number;
  contrast: number;
};

export const useImageMaterial = (props: Props) => {
  const { map, brightness, contrast, opacity, transparent, toneMapped, side } = props;

  // biome-ignore lint/correctness/useExhaustiveDependencies: to avoid material rectcreation need to update changing props in useEffects
  const imageMaterial = useMemo(() => {
    const material = new ImageMaterial({
      map,
      brightness,
      contrast,
      transparent,
      toneMapped,
      side,
    });
    return material;
  }, [map, brightness, contrast, transparent, toneMapped, side]);

  useEffect(() => {
    return () => imageMaterial.dispose();
  }, [imageMaterial]);

  useEffect(() => {
    if (opacity) {
      imageMaterial.uniforms.opacity.value = opacity;
      imageMaterial.uniformsNeedUpdate = true;
    }
  }, [imageMaterial, opacity]);

  useEffect(() => {
    imageMaterial.uniforms.brightness.value = brightness;
    imageMaterial.uniforms.contrast.value = 1 + contrast;
    imageMaterial.uniformsNeedUpdate = true;
  }, [imageMaterial, brightness, contrast]);

  return imageMaterial;
};
